/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsAnalyticsService
 */

export const getDocumentAnalyticsSummaryRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsAnalyticsService',
  rpcName: 'getDocumentAnalyticsSummary',
  auth: 'app',
  fingerprint: 'CiQqXCVXGuiTBoVAMHtC-yZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getVisitorsForDocumentRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsAnalyticsService',
  rpcName: 'getVisitorsForDocument',
  auth: 'app',
  fingerprint: 'WT7Cm9Yqd7UjoMIDNHiOYCZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getVisitsForDocumentAndViewerIdRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsAnalyticsService',
  rpcName: 'getVisitsForDocumentAndViewerId',
  auth: 'app',
  fingerprint: '8rSX8ysw7EhmRhnpKsysYyZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getVisitorsForDocumentAndSearchQueryRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsAnalyticsService',
  rpcName: 'getVisitorsForDocumentAndSearchQuery',
  auth: 'app',
  fingerprint: '6sI3Y8WhrgojoMIDNHiOYCZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};